import { createStore, applyMiddleware } from "redux";
import thunkMiddleware from "redux-thunk";
import persistedReducer from "./reducers";
import { createLogger } from "redux-logger";
// import  checkExpiredToken from './utils/checkExpireToken'
const loggerMiddleware = createLogger();
const middleware = [thunkMiddleware];

if (process.env.NODE_ENV === "development") {
    middleware.push(loggerMiddleware);
}

const store = createStore(persistedReducer, applyMiddleware(...middleware));

export default store;
